import tunnel from 'tunnel-rat';

export const pageHeaderTunnel = tunnel();

export const pageHeaderLeadingTunnel = tunnel();

export const pageHeaderTitleTunnel = tunnel();
